import { render, staticRenderFns } from "./ConfigQuery.vue?vue&type=template&id=1c81761a&scoped=true&"
import script from "./ConfigQuery.vue?vue&type=script&lang=js&"
export * from "./ConfigQuery.vue?vue&type=script&lang=js&"
import style0 from "./ConfigQuery.vue?vue&type=style&index=0&id=1c81761a&prod&lang=css&"
import style1 from "./ConfigQuery.vue?vue&type=style&index=1&id=1c81761a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c81761a",
  null
  
)

export default component.exports